import React from 'react';
import { PRODUCT_URL } from '../data/article';
interface RichTextProps {
  text: string;
}
const TOKEN = /(\*\*[^*]+\*\*|\[\[[^\]]+\]\])/g;

/**
 * Renders advertorial copy with two inline treatments:
 * **bold** for emphasis and [[link]] for in-story product links.
 */
export function RichText({
  text
}: RichTextProps) {
  const parts = text.split(TOKEN).filter(part => part !== '');
  return <>
      {parts.map((part, index) => {
      if (part.startsWith('**') && part.endsWith('**')) {
        return <strong key={index} className="font-semibold text-ink" data-id="element-35" data-mp="3jaodfn6ess3i">
              {part.slice(2, -2)}
            </strong>;
      }
      if (part.startsWith('[[') && part.endsWith(']]')) {
        return <a key={index} href={PRODUCT_URL} className="font-medium text-forest-mid underline decoration-forest-line decoration-2 underline-offset-2 transition-colors duration-150 ease-out hover:text-forest hover:decoration-forest" data-id="element-36" data-mp="3t5zpfxqfnl7k">
              {part.slice(2, -2)}
            </a>;
      }
      return <React.Fragment key={index} data-id="element-37" data-mp="36ylvui2lz3nq" data-mpi={index}>{part}</React.Fragment>;
    })}
    </>;
}